import { requestFetch } from '@/js/helpers';

const main = async () => {
    if(document.querySelector('.c-basics-badge') === null) return;
    //if(document.querySelector('.c-basics-badge').dataset.count) return;
    const resp = await requestFetch('/api/estate/badge_count');
    document.querySelectorAll('.c-basics-badge[data-favorite-count]').forEach((obj) => {
        const count = Number(resp.data.favorite) > 0 ? resp.data.favorite : 0;
        obj.textContent = count < 99 ? count : '99+';
        obj.dataset.count = count;
    });

    document.querySelectorAll('.c-basics-badge[data-history-count]').forEach((obj) => {
        const count = Number(resp.data.history) > 0 ? resp.data.history : 0;
        obj.textContent = count < 99 ? count : '99+';
        obj.dataset.count = count;
    });
}

export default main;
